// This file is automatically generated. Do not edit manually.

import { TaskTemplate } from "src/api/generated/postgres/db/types/tasks/tables/taskTemplate";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace TaskTemplateDataGridApi {
	export async function getTaskTemplates(): Promise<Array<TaskTemplate>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/tasks/taskTemplate/getTaskTemplates",
			method: "POST",
			data: {},
		});
		return response as Array<TaskTemplate>;
	}
}
